import { AiFillExclamationCircle } from '@react-icons/all-files/ai/AiFillExclamationCircle';
import { AiOutlineCheck } from '@react-icons/all-files/ai/AiOutlineCheck';
import { AiFillInfoCircle } from '@react-icons/all-files/ai/AiFillInfoCircle';

import React from 'react';
import classNames from 'classnames';
import { NotificationType } from './types';

const styles = {
  [NotificationType.Error]: 'text-red-700 bg-red-100 border-red-200',
  [NotificationType.Info]: 'text-blue-700 bg-blue-100 border-blue-200',
  [NotificationType.Success]: 'text-green-700 bg-green-100 border-green-200',
};

const icons = {
  [NotificationType.Error]: AiFillExclamationCircle,
  [NotificationType.Info]: AiFillInfoCircle,
  [NotificationType.Success]: AiOutlineCheck,
};

export interface WellProps {
  children: React.ReactNode;
  type: NotificationType;
  className?: string;
  'data-test-id'?: string;
}

export function Well(props: WellProps) {
  const Icon = icons[props.type];
  return (
    <div
      data-test-id={`${props['data-test-id']}-${props.type}`}
      className={classNames(
        'flex items-center rounded-md text-sm p-4',
        styles[props.type],
        props.className,
      )}
    >
      <div>
        <Icon className="h-5 w-5 mr-4" />
      </div>
      <p>{props.children}</p>
    </div>
  );
}
